import React from 'react';
import { SVG } from './SVG';

export const Credits = ({ className, stroke = 'currentColor' }) => (
  <SVG className={className} width={24}>
    <circle cx="12" cy="12" r="9" stroke={stroke} strokeLinecap="round" fill="none" />
    <rect 
      x="7.5" 
      y="7.5" 
      width="9" 
      height="9" 
      rx="1" 
      transform="rotate(45 12 12)" 
      stroke={stroke} 
      fill="none" 
      strokeLinecap="round" 
    />
  </SVG>
); 